import React from 'react';
import { Card } from './ui/Card';
import { BookOpen, Sparkles, Scissors, Zap, Eye, HandMetal } from 'lucide-react';
const modules = [{
  icon: <Sparkles className="w-8 h-8 text-purple-500" data-id="element-229" />,
  title: '1️⃣ Microneedling Profesional',
  desc: 'Aprendé uno de los tratamientos más solicitados para: Manchas, Cicatrices de acné, Antiage, Estrías. Servicio de ticket alto y alta demanda.',
  color: 'border-purple-500'
}, {
  icon: <Eye className="w-8 h-8 text-pink-500" data-id="element-230" />,
  title: '2️⃣ Micropigmentación Profesional',
  desc: 'Dominá: Diseño de cejas, Teoría del color, Técnica pelo a pelo, Shading, Labios. Uno de los servicios más rentables del sector.',
  color: 'border-pink-500'
}, {
  icon: <Scissors className="w-8 h-8 text-yellow-500" data-id="element-231" />,
  title: '3️⃣ Depilación con Cera Profesional',
  desc: 'Servicio base, constante y de bajo costo. Ideal para comenzar a generar ingresos rápidos.',
  color: 'border-yellow-500'
}, {
  icon: <Zap className="w-8 h-8 text-blue-500" data-id="element-232" />,
  title: '4️⃣ Aparatología + Depilación Láser',
  desc: 'Fundamentos técnicos + estructura de servicio rentable. Posicionamiento profesional inmediato.',
  color: 'border-blue-500'
}, {
  icon: <Eye className="w-8 h-8 text-indigo-500" data-id="element-233" />,
  title: '5️⃣ Lashista Profesional',
  desc: 'Extensiones de pestañas paso a paso. Servicio recurrente, Clientes frecuentes, Ingresos constantes.',
  color: 'border-indigo-500'
}, {
  icon: <HandMetal className="w-8 h-8 text-rose-500" data-id="element-234" />,
  title: '6️⃣ Manicuría Profesional',
  desc: 'Uno de los servicios más solicitados. Alta rotación, Demanda constante, Ingreso estable.',
  color: 'border-rose-500'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-20 bg-[#FDF2F8]" data-id="element-235">
      <div className="max-w-6xl mx-auto px-4" data-id="element-236">
        <div className="text-center mb-12 md:mb-16" data-id="element-237">
          <span className="text-[#BE185D] font-bold tracking-wider uppercase mb-2 block text-sm" data-id="element-238">
            ✅ LA SOLUCIÓN
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6" data-id="element-239">
            💎 MegaPack Estética Integral
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-240">
            No es un curso aislado. Es una formación completa, diseñada para que
            cualquier persona pueda aprender servicios reales del mercado
            estético, paso a paso y con criterio profesional.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 md:mt-8 text-sm md:text-lg font-bold text-gray-800" data-id="element-241">
            <span className="flex items-center" data-id="element-242">📖 Abrís el material</span>
            <span className="flex items-center" data-id="element-243">🧠 Entendés qué hacer</span>
            <span className="flex items-center" data-id="element-244">✍️ Aplicás con seguridad</span>
          </div>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-245">
          📚 ¿Qué incluye exactamente el MegaPack?
        </h3>
        <p className="text-center text-gray-500 mb-8 md:mb-12 uppercase tracking-widest font-semibold text-xs md:text-sm" data-id="element-246">
          Recibís 6 TOMOS PROFESIONALES (60 páginas cada uno)
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-247">
          {modules.map((module, idx) => <Card key={idx} className={`p-6 border-t-4 ${module.color} hover:shadow-2xl transition-shadow duration-300`} data-id="element-248">
              <div className="mb-4 bg-pink-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-249">
                {module.icon}
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-250">
                {module.title}
              </h4>
              <p className="text-gray-600 text-center text-sm leading-relaxed" data-id="element-251">
                {module.desc}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}